/*******************************************
 * [COMPONENT]: MAIN CART
 ********************************************/
if (!customElements.get('l-main-cart')) {
	class LTAMainCart extends HTMLElement {
		constructor() {
			super()

			this.updatedVariants = []
			this._onQuantityChange = l_debounce(this._onQuantityChange.bind(this), 200)
			this._onRemoveLineItem = this._onRemoveLineItem.bind(this)
			this._onCartUpdate = this._onCartUpdate.bind(this)
		}

		connectedCallback() {
			this.updatedVariants = []

			this.addEventListener('change', this._onQuantityChange)
			this.addEventListener('click', this._onRemoveLineItem)

			document.addEventListener('l:product:added', this._onCartUpdate)
			document.addEventListener('l:cart:error', this._onCartUpdate)
			document.addEventListener('l:cart:discount:applied', this._onCartUpdate)
		}

		_onRemoveLineItem(event) {
			const removeBtn = event.target.closest('[data-remove-line-item]')
			if (!removeBtn) return

			event.preventDefault()

			const lineItemEl = event.target.closest('[data-cart-line-item]')
			if (lineItemEl) {
				this._updateCartLine(lineItemEl, 0)
			}
		}

		_onQuantityChange(event) {
			const lineItemEl = event.target.closest('[data-cart-line-item]')
			if (!lineItemEl) return

			const quantity = parseInt(event.target.value || 1, 10)

			this._updateCartLine(lineItemEl, quantity)
		}

		_updateCartLine(lineItemEl, quantity) {
			console.log({ lineItemEl, quantity })

			if (!lineItemEl) return

			this.classList.add('is-loading')

			const line = parseInt(lineItemEl.dataset.index, 10)
			const variantId = lineItemEl.dataset.variantId

			ltaCartService
				.changeCartLineItem({
					line,
					quantity,
					sections_url: window.location.pathname,
					sections: this._getSectionsToRender().map((section) => section.id),
				})
				.then((cart) => {
					if (cart?.status === 422) {
						this._handleCartError(cart, lineItemEl)

						return
					}

					this._updateCartData(cart.sections[this.dataset.sectionId])

					this.dispatchEvent(new CustomEvent('l:cart:updated', { detail: { cart }, bubbles: true }))
					this.updatedVariants.push(variantId)
				})
				.catch((error) => {
					console.error(error)
				})
				.finally(() => {
					this.classList.remove('is-loading')
				})
		}

		_handleCartError(error = { description: '' }, lineItemEl) {
			// Add error message to line item
			const errorMessageEl = lineItemEl.querySelector('[data-error-message]')

			if (errorMessageEl) {
				errorMessageEl.textContent = error.description
				errorMessageEl.parentElement.classList.remove('l-hidden')
			}
		}

		_onCartUpdate() {
			this.classList.add('is-loading')

			fetch(`${window.LTATheme.routes.cart_url}?section_id=${this.dataset.sectionId}`)
				.then((res) => res.text())
				.then((html) => {
					this._updateCartData(html)
				})
				.finally(() => {
					this.classList.remove('is-loading')
				})
		}

		_updateCartData(html) {
			const newCartDrawerHTML = l_getSectionDOM(html, '#main-cart')
			this.classList.toggle('is-empty', newCartDrawerHTML?.classList.contains('is-empty'))

			const selectors = ['[data-cart-inner]', '[data-cart-subtotal]', '[data-cart-footer]']

			selectors.forEach((selector) => {
				const newSection = newCartDrawerHTML?.querySelector(selector)
				const oldSection = this.querySelector(selector)
				if (newSection && oldSection) oldSection.innerHTML = newSection.innerHTML
			})
		}

		_getSectionsToRender() {
			return [
				{
					id: this.dataset.sectionId,
					selector: '.shopify-section',
				},
			]
		}
	}

	customElements.define('l-main-cart', LTAMainCart)
}

/*******************************************
 * [COMPONENT]: DISCOUNT CODE
 ********************************************/

if (!customElements.get('l-cart-discount-code')) {
	class LTAMainCartDiscountCode extends HTMLElement {
		constructor() {
			super()

			this.onSubmit = this.onSubmit.bind(this)
			this.onInput = l_debounce(this.onInput.bind(this), 200)
		}

		connectedCallback() {
			this.inputEl = this.querySelector('[data-discount-input]')
			this.submitEl = this.querySelector('[data-submit]')
			this.removeDiscountEls = this.querySelectorAll('[data-remove-discount]')
			this.cartEl = document.getElementById('main-cart') || document.getElementById('cart-drawer')

			this.parseDiscountCodes()

			this.addRemoveDiscountListeners()

			if (this.submitEl) this.submitEl.addEventListener('click', this.onSubmit)
			if (this.inputEl) this.inputEl.addEventListener('input', this.onInput)
		}

		parseDiscountCodes() {
			this.discountCodes = (this.dataset.discountCodeCodes || '').split(',').filter(Boolean)
			this.discountCodeCount = this.discountCodes.length
		}

		onInput() {
			if (this.submitEl && this.inputEl) {
				this.submitEl.disabled = this.inputEl.value.trim().length === 0
			}
		}

		onSubmit(event) {
			event.preventDefault()

			if (this.cartEl) this.cartEl.classList.add('is-loading')
			if (this.submitEl) this.submitEl.classList.add('l-button-loading')

			const codes = Array.from(new Set([...(this.discountCodes || []), this.inputEl?.value || ''])).filter(Boolean)
			const discount = codes.join(',')

			this.updateCodes(discount)
		}

		addRemoveDiscountListeners() {
			this.removeDiscountEls.forEach((el) => {
				el.addEventListener('click', () => {
					el.classList.add('l-button-loading')
					const discountCode = el.dataset.removeDiscount
					const newDiscountCodes = this.discountCodes.filter((code) => code !== discountCode).join(',')
					this.updateCodes(newDiscountCodes)
				})
			})
		}

		updateCodes(discount) {
			fetch(window.LTATheme.routes.cart_update_url, {
				...l_fetchConfig(),
				body: JSON.stringify({ discount }),
			})
				.then((res) => res.json())
				.then((response) => {
					this.dispatchEvent(
						new CustomEvent('l:cart:discount:applied', {
							detail: { response },
							bubbles: true,
						})
					)
				})
				.finally(() => {
					l_debounce(() => {
						if (this.submitEl) this.submitEl.classList.remove('l-button-loading')
						if (this.inputEl) this.inputEl.value = ''
					}, 500)()
				})
		}
	}

	customElements.define('l-cart-discount-code', LTAMainCartDiscountCode)
}

